import { bindActionCreators, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';

import AsyncTasksPage from './AsyncTasksPage';
import State from '../../app/store/state';
import { ActionCreators as AsyncActionCreators, AsyncTasksTypes } from '../../utils/asyncTasks';
import { ActionCreators as BeneficiaryActionCreators } from '../beneficiaries';
import { hasFeatureAccess } from '../../login/auth';
import { ManagerPermission } from '../../permission-profiles/permission';

const unblockMapping = {
    beneficiaryId: 1,
    reason: 2,
    source: 3,
};

function mapDispatchToProps(dispatch: ThunkDispatch<unknown, void, AnyAction>) {
    return {
        authorizeTask: bindActionCreators(AsyncActionCreators.authorizeAsyncTask, dispatch),
        downloadFile: bindActionCreators(AsyncActionCreators.downloadFile, dispatch),
        loadAsyncTasksList: (page, limit) =>
            dispatch(AsyncActionCreators.loadAsyncTasksList(page, limit, AsyncTasksTypes.UNBLOCK_BENEFICIARIES)),
        uploadFile: (data: File, dryRun?: boolean, dryRunAsyncTaskId?: string) => {
            const params: Record<string, unknown> = {
                data,
                mapping: unblockMapping,
                startIndex: 2,
            };

            if (dryRun) {
                params.dryRun = true;
            }
            if (dryRunAsyncTaskId) {
                params.dryRunAsyncTaskId = dryRunAsyncTaskId;
            }

            return dispatch(BeneficiaryActionCreators.unblockBeneficiaries(params));
        },
        clearUploadTask: bindActionCreators(BeneficiaryActionCreators.clearUploadTask, dispatch),
    };
}

function mapStateToProps(state: State) {
    const hasBeneficiariesMassUnblockPost = hasFeatureAccess(
        state.auth,
        ManagerPermission.beneficiariesMassUnblockPost
    );
    const hasBeneficiariesMassUnblockPark = hasFeatureAccess(
        state.auth,
        ManagerPermission.beneficiariesMassUnblockPark
    );
    const canDownload = hasFeatureAccess(state.auth, ManagerPermission.beneficiariesDownload);

    return {
        canPark: hasBeneficiariesMassUnblockPark,
        canPost: hasBeneficiariesMassUnblockPost,
        canDownload: canDownload,
        tasks: state.asyncTasks.asyncTasks[AsyncTasksTypes.UNBLOCK_BENEFICIARIES],
        authorizedManagerId: state.auth.manager ? state.auth.manager.id : null,
        exampleUploadFile: 'BeneficiaryMassUnblockTest.xlsx',
        name: 'Unblock Beneficiaries',
        uploadDescription: 'Upload XLSX file with unblocked beneficiaries with proper structure.',
        exampleLinkTitle: 'See example mass unblock file',
        uploadTaskState: state.uploadTaskState,
        shouldRunDryRun: true,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect(mapStateToProps, mapDispatchToProps)(AsyncTasksPage as any);
